import React from "react";
import "./Footer.css";

function Footer() {
  const currentYear = new Date().getFullYear();
  
  return (
    <div className="footer">
      <ul className="footer-languages">
        {/* Technology icons using better Unicode symbols */}
        <li className="tech-icon react" title="React">⚛️</li>
        <li className="tech-icon js" title="JavaScript">
          <span className="js-icon">JS</span>
        </li>
        <li className="tech-icon html" title="HTML">
          <span className="html-icon">&lt;/&gt;</span>
        </li>
        <li className="tech-icon css" title="CSS">
          <span className="css-icon">CSS</span>
        </li>
        <li className="tech-icon docker" title="Docker">🐋</li>
        <li className="tech-icon postgres" title="PostgreSQL">
          <span className="db-icon">SQL</span>
        </li>
        
        {/* Social links with better styling */}
        <a href="https://github.com/cade3031/" className="github" target="_blank" rel="noopener noreferrer">
          <span className="social-icon">GH</span>
        </a>
        <a href="https://www.linkedin.com/in/cade/-wied-493228287" className="linkedin" target="_blank" rel="noopener noreferrer">
          <span className="social-icon">in</span>
        </a>
      </ul>
    </div>
  );
}

export default Footer;